module.exports = __webpack_public_path__ + "static/img/pc.2a75fe6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/长城书院/pc.svg
// module id = cUg0
// module chunks = 16